import React, { useState } from 'react';
import Button from '../../../components/base/Button';

export default function GallerySection() {
  const [activeFilter, setActiveFilter] = useState('all');
  const [lightboxImage, setLightboxImage] = useState<string | null>(null);

  const galleryCategories = [
    { id: 'all', name: 'Semua', icon: 'ri-grid-line' },
    { id: 'food', name: 'Makanan', icon: 'ri-restaurant-line' },
    { id: 'interior', name: 'Interior', icon: 'ri-home-line' },
    { id: 'atmosphere', name: 'Suasana', icon: 'ri-image-line' }
  ];

  const galleryImages = [
    {
      id: 1,
      src: 'https://public.readdy.ai/ai/img_res/ca2b7911813c99dd403c2e7ae3ebcd94.jpg',
      category: 'food',
      title: 'Tonkotsu Ramen Premium',
      description: 'Kuah kental dengan chashu premium'
    },
    {
      id: 2,
      src: 'https://readdy.ai/api/search-image?query=Elegant%20sushi%20platter%20with%20fresh%20nigiri%2C%20sashimi%2C%20rolls%2C%20wasabi%2C%20pickled%20ginger%2C%20wooden%20board%20presentation%2C%20high-end%20Japanese%20restaurant%20quality%2C%20artistic%20food%20arrangement&width=400&height=300&seq=gallery-food-002&orientation=landscape',
      category: 'food',
      title: 'Sushi & Sashimi Set',
      description: 'Koleksi sushi premium pilihan chef'
    },
    {
      id: 3,
      src: 'https://readdy.ai/api/search-image?query=Modern%20futuristic%20Japanese%20restaurant%20interior%20with%20neon%20lighting%2C%20traditional%20elements%2C%20Torii%20gate%20decorations%2C%20elegant%20dining%20tables%2C%20atmospheric%20lighting%2C%20contemporary%20design&width=400&height=300&seq=gallery-interior-001&orientation=landscape',
      category: 'interior',
      title: 'Interior Futuristik',
      description: 'Perpaduan tradisional dan modern'
    },
    {
      id: 4,
      src: 'https://readdy.ai/api/search-image?query=Golden%20crispy%20tempura%20with%20shrimp%20and%20vegetables%2C%20light%20batter%20coating%2C%20served%20with%20tentsuyu%20sauce%2C%20elegant%20Japanese%20presentation%2C%20restaurant%20quality%20food%20photography&width=400&height=300&seq=gallery-food-003&orientation=landscape',
      category: 'food',
      title: 'Tempura Crispy',
      description: 'Tepung renyah dengan isian segar'
    },
    {
      id: 5,
      src: 'https://readdy.ai/api/search-image?query=Cozy%20Japanese%20restaurant%20dining%20atmosphere%20with%20customers%20enjoying%20meals%2C%20warm%20lighting%2C%20traditional%20decorations%2C%20authentic%20Japanese%20dining%20experience%2C%20social%20dining%20scene&width=400&height=300&seq=gallery-atmosphere-001&orientation=landscape',
      category: 'atmosphere',
      title: 'Suasana Hangat',
      description: 'Pengalaman makan yang berkesan'
    },
    {
      id: 6,
      src: 'https://readdy.ai/api/search-image?query=Traditional%20Japanese%20tatami%20private%20dining%20room%20with%20low%20tables%2C%20cushions%2C%20paper%20screens%2C%20authentic%20Japanese%20interior%20design%2C%20elegant%20private%20dining%20experience&width=400&height=300&seq=gallery-interior-002&orientation=landscape',
      category: 'interior',
      title: 'Ruang VIP Tatami',
      description: 'Pengalaman dining tradisional'
    },
    {
      id: 7,
      src: 'https://readdy.ai/api/search-image?query=Beautiful%20matcha%20latte%20with%20foam%20art%2C%20vibrant%20green%20color%2C%20traditional%20Japanese%20ceramic%20cup%2C%20artistic%20presentation%2C%20cafe%20atmosphere%2C%20premium%20matcha%20drink&width=400&height=300&seq=gallery-food-004&orientation=landscape',
      category: 'food',
      title: 'Matcha Latte Art',
      description: 'Seni dalam secangkir matcha'
    },
    {
      id: 8,
      src: 'https://readdy.ai/api/search-image?query=Japanese%20restaurant%20kitchen%20with%20chefs%20preparing%20food%2C%20professional%20kitchen%20equipment%2C%20clean%20modern%20setup%2C%20culinary%20artistry%20in%20action%2C%20behind%20the%20scenes%20cooking&width=400&height=300&seq=gallery-atmosphere-002&orientation=landscape',
      category: 'atmosphere',
      title: 'Dapur Professional',
      description: 'Chef berpengalaman bekerja'
    },
    {
      id: 9,
      src: 'https://readdy.ai/api/search-image?query=Elegant%20sake%20service%20set%20with%20traditional%20ceramic%20bottles%20and%20cups%2C%20wooden%20tray%2C%20warm%20lighting%2C%20premium%20Japanese%20alcohol%20presentation%2C%20sophisticated%20dining%20experience&width=400&height=300&seq=gallery-food-005&orientation=landscape',
      category: 'food',
      title: 'Sake Premium',
      description: 'Koleksi sake pilihan terbaik'
    }
  ];

  const filteredImages = activeFilter === 'all' 
    ? galleryImages 
    : galleryImages.filter(img => img.category === activeFilter);

  return (
    <section id="gallery" className="py-20 bg-gradient-to-b from-black to-gray-900 dark:from-gray-900 dark:to-gray-800">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-5xl font-black text-white mb-6" style={{ fontFamily: '"Noto Sans JP", serif' }}>
            Galeri <span className="text-red-500">TAKEYA</span>
            <span className="block text-3xl text-yellow-400 mt-2">ギャラリー</span>
          </h2>
          <div className="flex items-center justify-center space-x-4 mb-8">
            <div className="h-px w-20 bg-gradient-to-r from-transparent to-red-500"></div>
            <div className="text-yellow-400 text-lg font-bold" style={{ fontFamily: '"Orbitron", sans-serif' }}>
              VISUAL EXPERIENCE
            </div>
            <div className="h-px w-20 bg-gradient-to-l from-transparent to-red-500"></div>
          </div>
          <p className="text-gray-300 text-lg max-w-2xl mx-auto">
            Jelajahi koleksi visual dari pengalaman kuliner Jepang autentik, interior futuristik, dan suasana yang memukau di TAKEYA
          </p>
        </div>

        {/* Filter Buttons */}
        <div className="flex flex-wrap justify-center gap-4 mb-12">
          {galleryCategories.map((category) => (
            <button
              key={category.id}
              onClick={() => setActiveFilter(category.id)}
              className={`flex items-center space-x-2 px-6 py-3 rounded-full font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer ${
                activeFilter === category.id
                  ? 'bg-gradient-to-r from-red-600 to-yellow-600 text-white shadow-lg transform scale-105'
                  : 'bg-gray-800 text-gray-300 hover:bg-gray-700 hover:text-white'
              }`}
            >
              <i className={`${category.icon} w-4 h-4 flex items-center justify-center`}></i>
              <span>{category.name}</span>
              <span className="bg-white/20 text-xs px-2 py-1 rounded-full">
                {category.id === 'all' ? galleryImages.length : galleryImages.filter(img => img.category === category.id).length}
              </span>
            </button>
          ))}
        </div>

        {/* Gallery Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {filteredImages.map((image) => (
            <div
              key={image.id}
              className="group relative bg-gradient-to-br from-gray-800/50 to-gray-900/50 backdrop-blur-sm rounded-2xl border border-red-500/20 overflow-hidden hover:border-red-500/40 transition-all duration-300 cursor-pointer"
              onClick={() => setLightboxImage(image.src)}
            >
              <div className="relative overflow-hidden">
                <img
                  src={image.src}
                  alt={image.title}
                  className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                
                {/* Overlay Content */}
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="text-center">
                    <div className="w-12 h-12 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-3">
                      <i className="ri-eye-line text-white w-6 h-6 flex items-center justify-center"></i>
                    </div>
                    <p className="text-white font-semibold">Lihat Gambar</p>
                  </div>
                </div>
              </div>

              <div className="p-4">
                <h3 className="text-white font-bold text-lg mb-2 group-hover:text-red-400 transition-colors">
                  {image.title}
                </h3>
                <p className="text-gray-300 text-sm">
                  {image.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Section */}
        <div className="text-center bg-gradient-to-r from-red-900/20 to-yellow-900/20 backdrop-blur-sm rounded-3xl border border-red-500/20 p-12">
          <h3 className="text-3xl font-bold text-white mb-4">
            Rasakan Langsung Pengalaman <span className="text-red-400">TAKEYA</span>
          </h3>
          <p className="text-gray-300 text-lg mb-8 max-w-2xl mx-auto">
            Foto tidak dapat menggambarkan kelezatan sepenuhnya. Datang dan nikmati pengalaman kuliner Jepang autentik di restoran kami!
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              variant="primary" 
              size="lg"
              onClick={() => {
                const element = document.querySelector('#reservation');
                if (element) element.scrollIntoView({ behavior: 'smooth' });
              }}
              className="shadow-2xl shadow-red-500/50 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-calendar-line mr-2 w-5 h-5 flex items-center justify-center"></i>
              Reservasi Sekarang
            </Button>
            <Button 
              variant="outline" 
              size="lg"
              onClick={() => {
                const element = document.querySelector('#contact');
                if (element) element.scrollIntoView({ behavior: 'smooth' });
              }}
              className="shadow-2xl shadow-yellow-500/50 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-map-pin-line mr-2 w-5 h-5 flex items-center justify-center"></i>
              Lihat Lokasi
            </Button>
          </div>
        </div>
      </div>

      {/* Lightbox Modal */}
      {lightboxImage && (
        <div 
          className="fixed inset-0 bg-black/90 backdrop-blur-sm z-50 flex items-center justify-center p-6"
          onClick={() => setLightboxImage(null)}
        >
          <div className="relative max-w-4xl max-h-full">
            <img
              src={lightboxImage}
              alt="Gallery Image"
              className="max-w-full max-h-full object-contain rounded-2xl"
            />
            <button
              onClick={() => setLightboxImage(null)}
              className="absolute top-4 right-4 w-10 h-10 bg-red-600 hover:bg-red-700 text-white rounded-full flex items-center justify-center transition-colors cursor-pointer"
            >
              <i className="ri-close-line w-5 h-5 flex items-center justify-center"></i>
            </button>
          </div>
        </div>
      )}
    </section>
  );
}